<script>
import "@/assets/css/user-center.css"
const baseUrl = process.env.VUE_APP_BASE_API
import {
  Add,
  GetList,
  SaveOrderStatus,
  GetCrossFlowList,
  GetServiceNo,
  SaveOrderFile,
  RceivingSampleLabView,
  SubmitOrderPay,
  SubmitOrderEvaluate,
  OrderRefundEdit,
  OrderInvoiceEdit
} from "@/api/general-api"
import OrderFiles from "@/components/OrderFiles"
import Vue from "vue"

export default {
  name: 'CrossOrders',
  data() {
    return {
      searchKeyword: '',
      activeName: '?',
      orders: [],
      orderStatus: [],
      currentOrder: null,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        orderField: "CreateTime",
        orderType: "descend",
      },
      params: {
        ServiceName: "",
        OrderNo: "",
        ServiceCountry: ""
      },
      checkedOrders: [],
      checkAll: false,
    }
  },
  mounted() {
    this.GetCrossFlowList(this.InitialData)
  },
  render(h) {
    return (
      <el-container class="flex-column">
        <div class="full-width flex bg-white mg-b" style="position:relative;padding:15px 10px;">
          <b class="desc-content">我的【跨国服务】订单</b>
          <el-button icon="el-icon-shopping-cart-1" style="position:absolute;right:10px;top:5px;bottom:5px" type="primary" size="small">购买服务</el-button>
        </div>
        <div class="full-width bg-white mg-b pd-10 no-header-underline">
          {this.renderSearchPanel()}
          {this.renderTabPanel()}
          {this.renderOrderList()}
          {this.renderPagination()}
        </div>
      </el-container>
    )
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler() {
        this.handleGetList()
      }
    }
  },
  methods: {
    onMakeInvoiceBtnClick() {
      if (this.checkedOrders.length == 0) {
        return this.$message.error("请先选中订单")
      }
      this.onOpenMakeInvoiceDialog(this.checkedOrders)
    },
    onOpenMakeInvoiceDialog(orders) {
      const GirConstructor = Vue.extend(MakeInvoice);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options({ orders: orders });
      nodeObj.Open((shopList, close) => {
        let postParam = {
          data: shopList
        }
        OrderInvoiceEdit(postParam).then(res => {
          console.log(res);
          if (!res.success) {
            return this.$message.error('申请开票失败' + res.msg)
          }
          this.$message.success("申请开票成功！")
          close()
          this.handleGetList()
        })
      });
    },

    onParamsInput(key, value) {
      this.params[key] = value
    },
    renderSearchPanel() {
      return (
        <el-row type="flex" justify="start" align="middle" style="flex-wrap:wrap;border-bottom:1px solid #f0f0f0;padding-bottom:10px;">
          <el-col span={5}>
            <div style="display:flex;flex-direction: row;align-items:center;">
              <small class="text-dark" style="width:70px;text-align:right;">服务名称：</small>
              <el-input placeholder="请输入服务名称" size="mini" style="flex:1;"
                value={this.params.ServiceName}
                on-input={(val) => this.onParamsInput('ServiceName', val)}
                on-change={() => this.InitialData()}
              />
            </div>
          </el-col>
          <el-col span={5}>
            <div style="display:flex;flex-direction: row;align-items:center;">
              <small class="text-dark" style="width:60px;text-align:right;">订单号：</small>
              <el-input placeholder="请输入订单号" size="mini" style="flex:1;"
                value={this.params.OrderNo}
                on-input={(val) => this.onParamsInput('OrderNo', val)}
                on-change={() => this.InitialData()} />
            </div>
          </el-col>
          <el-col span={5}>
            <div style="display:flex;flex-direction: row;align-items:center;">
              <small class="text-dark" style="width:70px;text-align:right;">服务国家：</small>
              <el-input placeholder="请输入服务国家" size="mini" style="flex:1;"
                value={this.params.ServiceCountry}
                on-input={(val) => this.onParamsInput('ServiceCountry', val)}
                on-change={() => this.InitialData()} />
            </div>
          </el-col>

        </el-row>
      )
    },
    /** 渲染订单类型Tab */
    renderTabPanel() {
      const { orderStatus, activeName } = this
      const renderTabLi = () => {
        return orderStatus.map((l, index) => {
          const itemKey = `${l.name}-${index}`
          const className = `a-normal-tab ${l.name.toString() === activeName ? 'active' : ''}`
          const urlParam = `?f=Status&v=${l.name}`
          const url = `/users/#/center/crossorders${urlParam}`
          return (
            <li class="nav-row-item" key={itemKey}>
              {/*<a class={className} onClick={() => this.onOrderStatusTabClick(l.name, href)}>{l.label}</a>*/}
              <a class={className} href={url}>{l.label}</a>
            </li>
          )
        })
      }
      return (
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          style="padding: 10px 0"
        >
          <ul class="tab-nav">
            {/*<el-checkbox style="margin-right:20px" indeterminate={this.isIndeterminate} v-model={this.checkAll} onChange={this.handleCheckAllChange}></el-checkbox>*/}
            {renderTabLi()}
          </ul>
        </el-row>
      )
    },
    /** 渲染订单列表 */
    renderOrderList() {
      const { orders } = this
      const renderHandle = () => {
        if (!Array.isArray(orders) || !orders.length) {
          return <el-empty description="没有订单哦~快去下单吧!" />
        }
        return orders.map(order => {
          return this.renderOrder(order)
        })
      }
      return (
        <div class="order-content">
          <el-checkbox-group v-model={this.checkedOrders} onChange={this.handleCheckedOrdersChange}>
            {renderHandle()}
          </el-checkbox-group>
        </div>
      )
    },
    /** 渲染单个订单 {this.renderOrderFooter(order)} */
    renderOrder(order) {
      return (
        <div class="order-box" key={order.ID}>
          {this.renderOrderHeader(order)}
          {this.renderOrderBody(order)}

        </div>
      )
    },
    /** 渲染订单头部 */
    renderOrderHeader(order) {
      return (
        <el-row
          type="flex"
          justify="start"
          align="middle"
          class="bg-gray under-line pd-10"
        >
          <div class="order-item"><span class="title">订单号 :</span><span class="value">{order.OrderNo}</span></div>
          <div class="order-item"><span class="title">创建时间 :</span><span class="value">{order.CreateTime}</span></div>
          <div class="order-item"><span class="title">状态 :</span><span class="value">{order.StatusName}</span></div>
          <div class="order-item"><span class="title">服务类别 :</span><span class="value">{order.ServiceCategory}</span></div>

        </el-row>
      )
    },
    /** 渲染订单主体 */
    renderOrderBody(order) {
      const tableData = [order]
      const ServeNameScopedSlots = {
        default: props => {
          const ServicePics = props.row.ServicePics
          const picUrl = Array.isArray(ServicePics) && ServicePics.length ? ServicePics[0].url : null;
          return (
            <el-row type={'flex'}>
              <el-image src={baseUrl + picUrl} style="width: 80px; height: 80px" />
              <div style="flex:1;padding-left:5px;line-height:18px;">
                <el-row style="margin:5px 0;"><strong>{props.row.ServiceName}</strong></el-row>
                <el-row><small>{props.row.ServiceName2}</small></el-row>
              </div>
            </el-row>
          );
        },
      }

      const optScopedSlots = {
        default: props => {
          if (props.row.ServiceCategory === '知识产权') {
            return (
              <el-row type={'flex'} justify={'center'} style="flex-wrap:wrap">
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 1)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">商标注册</el-button>
              </el-row>
            )
          } else if (props.row.ServiceCategory === 'VAT合规') {
            return (
              <el-row type={'flex'} justify={'center'} style="flex-wrap:wrap">
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 2)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">VAT税号</el-button>
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 3)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">VAT申报</el-button>
              </el-row>
            )
          } else if (props.row.ServiceCategory === 'EPR合规') {
            return (
              <el-row type={'flex'} justify={'center'} style="flex-wrap:wrap">
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 4)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">EPR税号</el-button>
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 5)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">EPR申报</el-button>
              </el-row>
            )
          } else {
            return (
              <el-row type={'flex'} justify={'center'} style="flex-wrap:wrap">
                <el-button
                  on-click={() => this.onOpenBrandEditDialog(props.row, 6)}
                  style="margin:2px;" disabled={props.row.Status > 0}
                  size="mini" plain type="default" icon="el-icon-edit">其他服务</el-button>
              </el-row>
            );
          }
        },
      }
      return (
        <el-table
          data={tableData}
          style="width: 100%">
          <el-table-column prop="ServiceName" label="服务名称" min-width="260" scopedSlots={ServeNameScopedSlots}>
          </el-table-column>
          <el-table-column prop="ServiceCountry" label="服务国家" width="110" align="center"></el-table-column>
          <el-table-column prop="OriginalPrice" label="原价" width="110" align="center" className="text-bold text-dark"></el-table-column>
          <el-table-column prop="Price" label="售价" width="110" align="center" className="text-bold text-danger"></el-table-column>
          <el-table-column prop="Quantity" label="数量" width="110" align="center" className="text-bold text-dark"></el-table-column>
          <el-table-column prop="PriceAgioed" label="商品优惠金额" width="120" align="center" className="text-bold text-error"></el-table-column>
          <el-table-column prop="OrderAmt" label="小计" width="110" align="center" className="text-bold text-danger"></el-table-column>
          <el-table-column prop="RefundAmt" label="退款金额" width="110" align="center"></el-table-column>
          <el-table-column prop="ReceiveAmt" label="订单实付金额" width="120" align="center" className="text-bold text-danger"></el-table-column>
          <el-table-column prop="StatusName" label="订单状态" width="110" align="center"></el-table-column>
          <el-table-column prop="ID" label="操作" align="center" width="150" scopedSlots={optScopedSlots}></el-table-column>
        </el-table>
      )
    },
    /** 渲染草稿报告 */
    renderDemoReport(order) {
      const { DemoReport } = order;
      if (Array.isArray(DemoReport) && DemoReport.length) {
        return <div class="info-item label">
          <span>草稿报告：</span>
          {this.renderReportList(DemoReport)}
        </div>
      }
      return null
    },
    /** 渲染正式报告 */
    renderOfficialReport(order) {
      const { OfficialReport } = order;
      if (Array.isArray(OfficialReport) && OfficialReport.length) {
        return <div class="info-item label">
          <span>正式报告：</span>
          {this.renderReportList(OfficialReport)}
        </div>
      }
      return null
    },
    /** 渲染报告文件列表 */
    renderReportList(files) {
      return files.map(f => {
        const { name, url } = f
        return <a href={url} target="blank" class="under-line">{name}</a>
      })
    },
    /** 渲染订单脚部 */
    renderOrderFooter(order) {
      const storeUrl = `/Shop/Index/${order.DeptID}`
      const showReportListBtn =
        (order.OfficialReport && order.OfficialReport.length) ||
        (order.DemoReport && order.DemoReport.length)
      return (
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          class="pdr under-line"
          style="min-height: 40px"
        >
          <div class="store-box">
            {order.ShopName && <strong>
              <svg t="1651758838759" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15323" width="18" height="18"><path d="M861.87008 409.6c0 42.3424-34.46784 76.8-76.8 76.8a76.02176 76.02176 0 0 1-51.0976-19.99872L716.8 450.93888l-17.17248 15.4624c-28.52864 25.8048-73.65632 25.8048-102.1952 0l-17.16224-15.4624-17.17248 15.4624c-28.52864 25.8048-73.6256 25.8048-102.22592 0l-17.14176-15.4624-17.13152 15.4624c-28.60032 25.8048-73.66656 25.8048-102.26688 0L307.2 450.93888l-17.13152 15.4624c-14.336 12.94336-32.47104 19.99872-51.13856 19.99872-42.33216 0-76.8-34.4576-76.8-76.8l76.8-307.2h546.14016l76.8 307.2zM819.2 853.34016V532.39808c-10.92608 3.072-22.23104 5.20192-34.12992 5.20192-24.23808 0-47.84128-7.00416-68.27008-20.06016-40.86784 26.13248-95.67232 26.13248-136.52992 0-40.86784 26.0608-95.67232 26.0608-136.54016 0-40.8576 26.13248-95.66208 26.13248-136.52992 0a126.75072 126.75072 0 0 1-68.27008 20.06016c-11.89888 0-23.20384-2.12992-34.12992-5.20192v320.94208H102.4V921.6h819.2v-68.25984H819.2z m-375.47008 0H307.2v-204.8h136.52992v204.8zM716.8 785.07008H546.12992V648.54016H716.8v136.52992z" p-id="15324" fill="#083090"></path></svg>
              <a href={storeUrl} class="order-title-item under-line">{order.ShopName}</a>
            </strong>}

            {order.ExpressNumber && <strong>
              <a class="order-title-item under-line">{order.ExpressCompany}</a>
              <a class="order-title-item under-line">{order.ExpressNumber}</a>
            </strong>}

            {order.QQ && <strong>
              <svg t="1651758666657" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12736" width="18" height="18"><path d="M866.991 707.772c0 0-25.341 69.55-71.877 132.071 0 0 83.05 28.439 76.137 102.196 0 0 2.709 82.331-177.613 76.685 0 0-126.817-9.898-164.88-63.85l-33.53 0c-38.018 54.006-164.834 63.85-164.834 63.85-180.431 5.7-177.556-76.685-177.556-76.685-7.025-73.756 76.081-102.196 76.081-102.196-46.475-62.519-71.875-132.071-71.875-132.071-112.759 183.141-101.477-25.567-101.477-25.567 21.141-123.495 109.949-204.384 109.949-204.384-12.677-112.157 33.805-132.078 33.805-132.078 9.68-346.979 306.473-340.887 312.675-340.722 6.249-0.163 302.931-6.256 312.72 340.723 0 0 46.538 19.866 33.812 132.078 0 0 88.751 80.89 109.886 204.384 0.055-0.001 11.285 208.707-101.421 25.566l0 0 0 0z" p-id="12737" fill="#083090"></path></svg>

              <a href={`http://wpa.qq.com/msgrd?v=3&uin=${order.QQ}&site=qq&menu=yes`} target="_blank" class="order-title-item under-line">{order.QQ}</a>
            </strong>}
          </div>
          <el-row type="flex" justify="start" align="middle">
            {(order.RefundStatus === 1) && this.renderRefundBtn(order)}
            {(order.RefundStatus === 0) && (order.InvoiceStatus === 0) && (order.InvoiceStatus > 59) && this.renderMakeInvoiceBtn(order)}
            {(order.RefundStatus === 0) && (order.Status === 80) && this.renderOrderEvaluateBtn(order)}
            {(order.RefundStatus === 0) && showReportListBtn && this.renderReportListBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 70) && this.renderOrderFilesBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 30 && order.Status <= 60) && this.renderOrderSampleBtn(order)}
            {(order.RefundStatus === 0) && (order.PayAmt > 0 && order.Status >= 30) && this.renderPayBtn(order)}
            {(order.RefundStatus === 0) && (order.Status === 0) && this.renderSubmitOrderBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status < 40) && this.renderCancelOrderBtn(order)}
          </el-row>
        </el-row>
      )
    },
    /** 全选 */
    handleCheckAllChange(val) {
      this.checkedOrders = val ? this.orders : [];
      this.isIndeterminate = false;
      console.log(this.checkedOrders);
    },
    /** 多选订单 */
    handleCheckedOrdersChange(orders) {
      console.log(orders);
      let checkedCount = orders.length;
      this.checkAll = checkedCount === this.orders.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.orders.length;
    },
    /** 开票按钮 */
    renderMakeInvoiceBtn(order) {
      const onMakeInvoiceBtnClick = e => {
        e.stopPropagation()
        this.onOpenMakeInvoiceDialog([].concat(order))
      }
      return (
        <div
          class="success-btn small-btn"
          onClick={onMakeInvoiceBtnClick}
        >
          <span style="margin-left: 5px">开票</span>
        </div>)
    },
    /** 退款按钮 */
    renderRefundBtn(order) {
      const onRefundBtnClick = e => {
        e.stopPropagation()
        this.$prompt('确认申请退款吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入退款理由',
          type: 'warning',
        }).then((remark) => {
          let result = {
            DeptID: order.DeptID,
            GoodsDeptID: order.GoodsDeptID,
            OrderID: order.ID,
            OrderNo: order.OrderNo,
            OrderName: order.ServeName,
            OrderAmt: order.OrderAmt,
            PayAmount: order.ReceiveAmt,
            Payment: 'Offline',
            Remark: remark.value
          }
          console.log(result)
          const postData = {
            ID: '',
            data: JSON.stringify(result)
          }
          OrderRefundEdit(postData).then(res => {
            console.log(res)
            if (!res.success) {
              return this.$message.error("申请退款失败：" + res.msg)
            }
            this.$message.success("申请退款成功!")
          })
        }).catch(() => { });
      }

      return (
        <div
          class="save-btn small-btn"
          onClick={onRefundBtnClick}
        >
          <span style="margin-left: 5px">退款</span>
        </div>)
    },
    /** 报告列表Btn */
    renderReportListBtn(order) {
      const onReportListBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderReportListDialog(order)
      }
      const btnText = order.Status === 61 ? "草稿报告待确认" : "报告列表";
      const btnClassName = order.Status === 61 ? "danger-btn small-btn" : "success-btn small-btn";
      return (
        <div
          class={btnClassName}
          onClick={onReportListBtnClick}
        >
          <span style="margin-left: 5px">{btnText}</span>
        </div>)
    },

    /** 订单评价Btn */
    renderOrderEvaluateBtn(order) {
      const onOrderEvaluateBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderEvaluateDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderEvaluateBtnClick}
        >
          <span style="margin-left: 5px">订单评价</span>
        </div>)
    },
    /** 附件管理Btn */
    renderOrderFilesBtn(order) {
      const onOrderFilesBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderFilesDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderFilesBtnClick}
        >
          <span style="margin-left: 5px">附件管理</span>
        </div>)
    },
    /** 录入样品Btn */
    renderOrderSampleBtn(order) {
      const onOrderSampleBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderSampleEditDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderSampleBtnClick}
        >
          <span style="margin-left: 5px">录入样品</span>
        </div>)
    },
    /** 立即支付Btn */
    renderPayBtn(order) {
      const onPayBtnClick = e => {
        e.stopPropagation()
        this.onPayOrderAmount(order)
      }
      return (
        <div
          class="buy-btn small-btn"
          onClick={onPayBtnClick}
        >
          <span style="margin-left: 5px">立即支付</span>
        </div>)
    },
    /** 提交订单Btn */
    renderSubmitOrderBtn(order) {
      const onSubmitOrderBtnClick = e => {
        e.stopPropagation()
        this.onChangeOrderStatus(11, order.ID)
      }
      return (
        <div
          class="user-btn small-btn"
          onClick={onSubmitOrderBtnClick}
        >
          <span style="margin-left: 5px">提交订单</span>
        </div>)
    },
    /** 取消订单Btn */
    renderCancelOrderBtn(order) {
      const onCancelOrderBtnClick = e => {
        e.stopPropagation()
        this.onChangeOrderStatus(-9, order.ID)
      }
      return (
        <div
          class="danger-btn small-btn"
          onClick={onCancelOrderBtnClick}
        >
          <span style="margin-left: 5px">取消订单</span>
        </div>)
    },
    /** 渲染分布器 */
    renderPagination() {
      const { pagination } = this
      return <el-row type="flex" justify="end" align="middle">
        <el-pagination
          on-size-change={this.onPaginationSizeChange}
          on-current-change={this.onPaginationCurrentChange}
          on-current-page={pagination.currentPage}
          page-sizes={[20, 40, 60, 100, 500]}
          page-size={pagination.pageSize}
          layout="total, prev, pager, next"
          total={pagination.total}
        >
        </el-pagination>
      </el-row>
    },
    /** 每页显示数量改变事件 */
    onPaginationSizeChange(val) {
      this.pagination.pageSize = val;
      this.handleGetList();
    },
    /** 当前页改变事件 */
    onPaginationCurrentChange(val) {
      this.pagination.currentPage = val;
      this.handleGetList();
    },
    // --打开报告列表窗口
    onOpenOrderReportListDialog(order) {
      const DemoReport = order.DemoReport || []
      const OfficialReport = order.OfficialReport || []
      const compShow = {
        compPath: require('@/views/Order/components/ReportList.vue'),
        compProps: {
          demolist: [...DemoReport],
          officiallist: [...OfficialReport],
          id: order.ID,
          hidebtn: order.Status > 61
        },
        key: 'compShow'
      }
      const dlgOptions = {
        dialog: {
          title: '报告列表',
          width: '720px'
        },
        okBtn: {
          show: false,
          text: '确定'
        },
        cancleBtn: {
          show: false,
          text: '关闭'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compShow).Open((dlg, close) => {
        this.handleGetList();
        close();
      }, (_, close) => {
        this.handleGetList();
        close();
      })
    },
    // --打开商标注册信息编辑窗口 Type	商标：1，VAT税号：2，VAT申报：3，ERP税号：4，ERP申报：5，其他服务：6
    onOpenBrandEditDialog(order, Type = 1) {
      GetServiceNo({ Type }).then(res => {
        if (!res.success) {
          return this.$message.error("服务号获取失败：" + res.msg)
        }
        let compEdit = {
          compPath: require('@/views/Cross/BrandEdit.vue'),
          compRef: 'brandEditDlg',
          key: 'compEdit'
        }
        let title = "商标注册"
        let tbName = "CrossBorderBrand"

        if (Type === 2) {
          compEdit = {
            compPath: require('@/views/Cross/BrandVatEdit.vue'),
            compRef: 'brandEditDlg',
            key: 'compEdit'
          }
          title = "VAT税号"
          tbName = "CrossBorderVAT"
        }
        if (Type === 3) {
          compEdit = {
            compPath: require('@/views/Cross/BrandVatdEdit.vue'),
            compRef: 'brandEditDlg',
            key: 'compEdit'
          }
          title = "VAT申报"
          tbName = "CrossBorderVATD"
        }
        if (Type === 4) {
          compEdit = {
            compPath: require('@/views/Cross/BrandEprEdit.vue'),
            compRef: 'brandEditDlg',
            key: 'compEdit'
          }
          title = "EPR税号"
          tbName = "CrossBorderEPR"
        }
        if (Type === 5) {
          compEdit = {
            compPath: require('@/views/Cross/BrandEprdEdit.vue'),
            compRef: 'brandEditDlg',
            key: 'compEdit'
          }
          title = "EPR申报"
          tbName = "CrossBorderEPRD"
        }
        if (Type === 6) {
          compEdit = {
            compPath: require('@/views/Cross/BrandOtherEdit.vue'),
            compRef: 'brandEditDlg',
            key: 'compEdit'
          }
          title = "其他服务"
          tbName = "CrossBorderOther"
        }
        const compShow = {
          compPath: require('@/views/Order/components/ListShow.vue'),
          compProps: {
            list: [
              { key: 'OrderNo', prop: '订单编号', value: order.OrderNo },
              { key: 'ServiceNo', prop: '服务号', value: res.data.no },
              { key: 'ServiceName', prop: '服务名称', value: order.ServiceName || "/" },
              { key: 'ServiceSpecs', prop: '服务规格', value: order.ServiceSpecs || "/" },
            ]
          },
          key: 'compShow'
        }


        const dlgOptions = {
          dialog: {
            title,
            width: '1080px'
          },
          okBtn: {
            text: '提  交'
          },
          cancleBtn: {
            show: false,
            text: '取  消'
          }
        }
        return this.$commdlg().Options(dlgOptions).Component(compShow).Component(compEdit).Open((dlg, close) => {
          let f = null
          if (Array.isArray(dlg)) {
            f = (dlg.find(x => x.refKey === 'brandEditDlg') || {}).refComp
          } else {
            f = dlg.$refs.brandEditDlg[0]
          }

          if (f) {
            let data = f.GetData()
            if (data) {
              data = {
                OrderNo: order.OrderNo,
                ServiceNo: res.data.no,
                ServiceSpecs: order.ServiceSpecs,
                ServiceName: order.ServiceName,
                ...data
              }

              const postData = {
                Name: tbName,
                data: JSON.stringify(data)
              }
              Add(postData).then(res => {
                if (!res.success) {
                  return this.$message.error("提交失败：" + res.msg)
                }
                this.$message.success("提交成功")
                close()
              })
            }
          }
        })
      })

    },

    // --打开订单评价窗口
    onOpenOrderEvaluateDialog(order) {
      const compEdit = {
        compPath: require('@/views/Order/components/OrderEvaluate.vue'),
        compRef: 'OrderEvaluateDlg',
        key: 'compEdit'
      }
      const dlgOptions = {
        dialog: {
          title: '订单评价',
          width: '800px'
        },
        okBtn: {
          text: '提  交'
        },
        cancleBtn: {
          show: false,
          text: '取  消'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compEdit).Open((dlg, close) => {
        console.log('dlg', dlg)
        let f = null;
        if (Array.isArray(dlg)) {
          f = dlg.find(x => x.refKey === 'OrderEvaluateDlg').refComp
        } else {
          f = dlg.$refs.OrderEvaluateDlg[0]
        }

        if (f) {
          let data = f.GetData()
          if (data) {
            data = {
              OrderID: order.ID,
              ...data
            }
            const postData = {
              ID: order.ID,
              data: JSON.stringify(data)
            }
            SubmitOrderEvaluate(postData).then(res => {
              if (!res.success) {
                return this.$message.error("订单评价提交失败：" + res.msg)
              }
              this.$message.success("订单评价提交成功")
              close()
              this.handleGetList()
            })
          }
        }
      })
    },
    // --打开附件管理窗口
    onOpenOrderFilesDialog(order) {
      this.currentOrder = Object.assign({}, order)
      const files = this.currentOrder.OrderFile && Array.isArray(this.currentOrder.OrderFile) ? [...this.currentOrder.OrderFile] : []

      const GirConstructor = Vue.extend(OrderFiles);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options({ files, max: 8, acceptFileTypes: ['PDF', 'DOC', 'DOCX', 'RAR', 'ZIP', '7Z', 'XLS', 'XLSX', 'PPT', 'PPTX'], readOnly: false });
      nodeObj.Open((files, close) => this.handlePostReportFiles(files, order, close));

    },
    onPayOrderAmount(order) {
      return this.$router.push(`/orderpay/${order.ID}`)
    },
    handlePostOrderPay(obj, order, close) {
      SubmitOrderPay({ ID: order.ID, Payment: obj.Payment, PayAmount: obj.PayAmount, PayFile: JSON.stringify(obj.PayFile) }).then(res => {
        if (!res.success) {
          return this.$message.error('订单支付提交失败：' + res.msg)
        }
        this.$message.success('订单支付提交成功！')
        this.$nextTick(() => {
          this.handleGetList()
          if (typeof close === 'function') {
            close();
          }
        })

      })
    },
    /** 提交保存订单附件 */
    handlePostReportFiles(files, order, close) {
      SaveOrderFile({ OrderID: order.ID, ID: order.ID, OrderFile: JSON.stringify(files) }).then(res => {
        if (!res.success) {
          return this.$message.error('保存订单附件失败：' + res.msg)
        }
        this.$message.success('订单附件保存成功！')
        this.handleGetList()
        if (typeof close === 'function') {
          close();
        }
      })
    },
    // --获取字典
    GetCrossFlowList(callback) {
      GetCrossFlowList({ FlowType: '10' }).then(res => {
        if (!res.success) {
          return this.$message.error("订单状态数据获取失败：" + res.msg)
        }
        const flowList = res.data.sort((a, b) => a.FlowNo <= b.FlowNo ? -1 : 0)
        this.orderStatus = [{ name: '?', label: '全部订单' }, ...flowList.map(x => ({
          name: x.FlowNo,
          label: x.FlowName
        }))]
        // this.orderStatus = [{ name: '?', label: '全部订单' }]
        callback()
      })
    },
    InitialData() {
      this.handleGetList()
    },
    /** 改变订单状态 */
    onChangeOrderStatus(Status, ID) {
      SaveOrderStatus({ Status, ID }).then(res => {
        if (!res.success) {
          return this.$message.error('操作失败：' + res.msg)
        }
        this.$message.success('操作成功!')
        this.handleGetList()
      })
    },
    getGoodsImg(url) {
      return url.toUpperCase().startsWith('HTTP') ? url : process.env.VUE_APP_BASE_API == '/' ? url : process.env.VUE_APP_BASE_API + url;
    },
    getGoodsInfoUrl(o) {
      return `/Service/Detail/${o.GoodsAgentID}?l=${o.LabID}&a=${o.GoodsAttributeID}`
    },
    onSearching() {
      this.$message.success("Searching Finished!")
    },
    /** 获取订单状态值 */
    getOrderStautsName(Status) {
      const s = this.orderStatus.filter(x => x.name && x.name !== '?').find(x => {
        const n = x.name.substr(1)
        const [f, v] = n.split('&')
        const f_v = f.split('=')[1]
        const v_v = v.split('=')[1]
        if (f_v === 'Status') {
          if (v_v.includes(',')) {
            const [v1, v2] = v_v.split(',')
            return Status >= v1 && Status <= v2
          }
          if (v_v.includes('~')) {
            const [v1, v2] = v_v.split('~')
            return Status >= v1 && Status <= v2
          }
          return Status.toString() === v_v.toString()
        }
        return false
      })
      return s ? s.label : '获取状态异常'
    },
    /** 解析当前请求条件 */
    analysisGetListParam() {
      // ?f=Status&v=0 ?f=Status&v=10~20 ?f=PayAmt&v=!0
      const { query } = this.$route
      const { f, v } = query
      if (!f || !v) {
        this.activeName = '?'
        return []
      }

      this.activeName = v.toString()
      return [{
        SqlField: f,
        pattern: 'equal',
        value: v
      }]
    },
    onOrderStatusTabClick(orderStatusName, href) {
      console.log(' -- onOrderStatusTabClick --', orderStatusName, href)
      this.handleGetList()
    },
    /** 获取列表数据 */
    handleGetList() {
      const params = this.analysisGetListParam()
      if (this.params.OrderNo) {
        params.push({
          SqlField: "OrderNo",
          pattern: 'like',
          value: this.params.OrderNo
        })
      }
      if (this.params.ServiceName) {
        params.push({
          SqlField: "ServiceName",
          pattern: 'like',
          value: this.params.ServiceName
        })
      }
      if (this.params.ServiceCountry) {
        params.push({
          SqlField: "ServiceCountry",
          pattern: 'like',
          value: this.params.ServiceCountrys
        })
      }
      const queryParam = {
        Name: 'CrossBorderOrderView',
        searchEntity: JSON.stringify(params),
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orderField: 'CreateTime',
        orderType: 'descend'
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('订单数据获取失败：' + res.msg)
        }
        console.log(res)
        this.orders = [...res.data.rows.map(x => {
          x.ServicePics = x.ServicePics || []
          return x
        })]
        this.pagination.currentPage = res.data.currentPage;
        this.pagination.pageSize = res.data.pageSize;
        this.pagination.total = res.data.total;
      })
    }
  }
}
</script>
<style lang="scss">
.no-header-underline {
  .el-card__header {
    padding: 18px 20px;
    border-bottom: 0px solid #ebeef5 !important;
    box-sizing: border-box;
  }
}
</style>
<style lang="scss" scoped>
.tab-nav {
  display: flex;
  align-items: center;
  box-sizing: border-box;

  .nav-row-item {
    display: inline-block;
    box-sizing: border-box;
    padding: 5px 20px;

    .a-normal-tab {
      padding: 5px;
      color: #333;
      display: inline-block;
      border-bottom: 2px solid #fff;
      cursor: pointer;
      transition: all 0.5s linear;

      &:hover {
        color: #083090;
      }

      &.active {
        font-weight: 700;
        color: #083090;
        border-bottom: 2px solid #083090;
      }
    }
  }
}

.order-item {
  box-sizing: border-box;
  width: 350px;

  .title {
    font-weight: 700;
    margin-right: 10px;
  }

  .value {
    color: #00000073;
    font-size: 14px;
    font-weight: 400;
  }
}

.order-content {
  padding: 10px 0;
  box-sizing: border-box;

  .order-box {
    font-size: 12px !important;
    border: 1px solid #eaeaea;
    border-bottom: none;
    box-sizing: border-box;
    margin-bottom: 15px;

    &:last-child {
      border-bottom: 0px solid #eaeaea;
    }

    .store-box {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;

      strong {
        line-height: 18px;
        display: inline-flex;
        align-items: center;
        margin-right: 15px;
        margin-left: 3px;

        svg {
          margin-right: 2px;
        }

        a {
          font-size: 14px;
          color: #6c6c6c;
          font-weight: 500 !important;
        }
      }
    }

    .order-title-item {
      line-height: 20px;
      margin-right: 10px;
      color: #666;

      &.order-no {
        color: #000;
        font-weight: 600;
        font-size: 14px;

        &::before {
          content: "订单号:";
          font-size: 12px;
          color: #666;
        }
      }
    }

    .order-stat {
      font-size: 12px;
      color: #083090;
      font-weight: 700;

      &::before {
        content: "【";
      }

      &::after {
        content: "】";
      }
    }

    .order-opt-item {
      width: 28px;
      height: 28px;
      border: 1px solid #e6e6e6;
      border-radius: 50%;
      color: #083090;
      font-weight: 600;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s linear;

      &:hover {
        color: #fff;
        background: #c10015;
      }
    }

    .info-item {
      color: #6c6c6c !important;
      margin-right: 10px;

      b {
        font-weight: 600;
        color: #000;
      }

      &.label {
        &::before {
          content: "●";
          margin-right: 5px;
        }
      }
    }

    .goods-info {
      padding-left: 10px;

      a {
        font-size: 15px !important;
        color: #000 !important;
      }
    }

    .img-box {
      width: 84px;
      height: 84px;
      box-sizing: border-box;
      background: #f5f5f5;
      border-radius: 2px;
      margin: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-height: 100%;
        max-width: 100%;
      }
    }

    .primary-divider {
      width: 1px;
      min-height: 100px;
      margin: 0 10px;
      height: 100%;
      background: linear-gradient(#ffffff, #083090, #ffffff);
    }

    .order-error-box {
      width: 120px;

      .error-item {
        color: #ca4300;
        font-size: 14px;
        padding: 5px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border: 1px solid #f0f0f0;
        margin: 3px auto;

        i {
          font-size: 16px;
        }

        span {
          flex: 1;
          padding-left: 10px;
        }
      }
    }

    .price-box {
      width: 180px;
      padding: 10px;
      font-size: 12px;
      color: #666;

      .item-price-label {
        text-align: right;
        width: 75px;
      }

      .item-price {
        flex: 1;
        display: inline-flex;
        color: #ca4300;
        font-size: 19px;
        font-weight: 700;
        width: 60px;
        flex-direction: column;
        justify-content: center;

        &::before {
          color: #ca4300;
          content: "￥";
          font-size: 11px;
        }

        &.item-price-2 {
          margin-left: 10px;
          display: inline-block;
          color: #ca4300;
          font-size: 14px;
          font-weight: 700;
          width: 60px;
        }
      }
    }
  }
}
</style>